import React from 'react'
import Statement from 'Components/new/statement'
import classNames from 'classnames'
import { Image } from 'Components/view-image'

interface IProps {
  className?: string
  responsive?: boolean
}

const Copyright: React.FC<IProps> = ({ className, responsive }) => {
  return (
    <section
      className={classNames('tw-p-16 tw-bg-white', className, {
        'tw-flex md:tw-block tw-items-center': responsive,
      })}
    >
      <div
        className={classNames({
          'tw-mr-12 md:tw-mr-0': responsive,
        })}
      >
        <p className="tw-text-center tw-leading-24 tw-text-12 lg:tw-text-14">
          扫码下载懂车帝APP
        </p>
        <img
          src={require('static/dcd-code@3x.png')}
          width={130}
          height={130}
          className={classNames(
            'tw-w-126 tw-h-126 tw-block tw-mx-auto tw-mt-8',
            {
              'md:tw-mb-16': responsive,
              'tw-mb-16': !responsive,
            }
          )}
          alt="懂车帝二维码"
        />
      </div>
      <Statement />
    </section>
  )
}

export default Copyright
